import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import Logo from "./Logo";

// Barra superior (mismo aspecto que la de llaves): marca, pestañas opcionales y usuario/salir.
//   tabs = [{ clave, texto, badge? }]   tab = clave activa   onTab(clave)
export default function Barra({ tabs, tab, onTab, titulo = "Check-in" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [confirmSalir, setConfirmSalir] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const nombre = user?.nombre || user?.email || "";
  const inicial = (nombre[0] || "?").toUpperCase();

  const salir = () => {
    logout();
    nav("/login", { replace: true });
  };

  return (
    <div className={`topbar ${menuAbierto ? "topbar-open" : ""}`}>
      <div className="topbar-top">
        <div className="topbar-brand">
          <Logo className="topbar-logo" />
          Campus Home <span>· {titulo}</span>
        </div>
        <button className="topbar-toggle" onClick={() => setMenuAbierto((v) => !v)} aria-label="Menú">☰</button>
      </div>
      <div className="topbar-right">
        {tabs && (
          <div className="tabs">
            {tabs.map((t) => (
              <button key={t.clave} className={tab === t.clave ? "active" : ""}
                      onClick={() => { onTab(t.clave); setMenuAbierto(false); }}>
                {t.texto}
                {t.badge > 0 && <span className="tab-badge">{t.badge}</span>}
              </button>
            ))}
          </div>
        )}
        <div className="topbar-user">
          <div className="user-chip">
            <span className="avatar">{inicial}</span>
            <span className="topbar-name">{nombre}</span>
          </div>
          <button className="btn-salir" onClick={() => setConfirmSalir(true)}>
            <span aria-hidden="true">🚪</span> Salir
          </button>
        </div>
      </div>

      {confirmSalir && (
        <div className="modal-back" onMouseDown={() => setConfirmSalir(false)}>
          <div className="modal modal-sm" onMouseDown={(e) => e.stopPropagation()}>
            <h3>👋 ¿Salir de la aplicación?</h3>
            <p className="muted">Se cerrará la sesión de <b>{nombre}</b>.</p>
            <div className="modal-actions">
              <button className="btn" onClick={() => setConfirmSalir(false)}>Cancelar</button>
              <button className="btn btn-danger" onClick={salir}>Sí, salir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
